import React, { useMemo } from 'react';

import { SimpleElement } from './SimpleElement';

import { useInternalEditor } from '../editor/useInternalEditor';
import { NodeId } from '../interfaces';
import { NodeElement } from '../nodes/NodeElement';
import { useInternalNode } from '../nodes/useInternalNode';

export const DefaultRender = () => {
  const { query } = useInternalEditor();

  const { type, props, nodes, hydrationTimestamp } = useInternalNode(
    (node) => ({
      type: node.data.type,
      props: node.data.props,
      nodes: node.data.nodes,
      hydrationTimestamp: node._hydrationTimestamp,
    })
  );

  // fixes docs#3207
  const getNodesHydrationTimestamps = (nodes: NodeId[] = []) => {
    if (nodes.length === 0) return [];
    return nodes.reduce((acc, id) => {
      const childNode = query.node(id).get();
      const timestamp = childNode?._hydrationTimestamp || id;
      return [
        ...acc,
        timestamp,
        ...getNodesHydrationTimestamps(childNode?.data?.nodes || []),
      ];
    }, []);
  };
  const nodesHydrationTimestamps = getNodesHydrationTimestamps(nodes).join(',');

  return useMemo(() => {
    let children = props?.children;

    if (nodes && nodes.length > 0) {
      children = (
        <React.Fragment>
          {nodes.map((id: NodeId) => {
            const childNode = query.node(id).get();
            return (
              <NodeElement id={id} key={childNode?._hydrationTimestamp || id} />
            );
          })}
        </React.Fragment>
      );
    }

    const render = type ? React.createElement(type, props, children) : null;

    if (typeof type == 'string') {
      return <SimpleElement render={render} />;
    }

    return render;
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [type, props, hydrationTimestamp, nodes, query, nodesHydrationTimestamps]);
};
